// extracted by mini-css-extract-plugin
export default {"inbodyKeysTable":"fpqbNgcCTJWBFPQGI9n8"};